import { v4 as uuid } from "uuid";
import { format } from "date-fns";
import { useFormikContext } from "formik";

import { StagesContainerProps } from "./Stages.types";

import { CALCULATOR_STAGES, MAX_STAGES_LIMIT } from "constants/calculator";

import Stages from "./Stages";

const StagesContainer = ({
  activeTab,
  isDesktop,
  stagesOptions,
  calculatorType,
}: StagesContainerProps) => {
  const { values, setFieldValue } = useFormikContext<any>();

  const handleAddStageClick = () => {
    if (values.stages.length < MAX_STAGES_LIMIT) {
      setFieldValue("stages", [
        ...values.stages,
        {
          id: uuid(),
          type: CALCULATOR_STAGES.BUILDING_STAGE,
          date: "",
          fee: "0",
        },
      ]);
    }
  };

  const handleRemoveStageClick = (index) => {
    setFieldValue(
      "stages",
      values.stages.filter((_, stageIndex) => stageIndex !== index)
    );
  };

  const handleSortByDateClick = () => {
    const startStages = values.stages.slice(0, 2);
    const buildStages = values.stages.filter(
      (stage) => stage.type === CALCULATOR_STAGES.BUILDING_STAGE
    );
    const sortedBuildStages = buildStages.sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
    );
    const lastBuildStage = sortedBuildStages[sortedBuildStages.length - 1];
    const finishStage = values.stages.find(
      (stage) => stage.type === CALCULATOR_STAGES.FINISH_STAGE
    );

    const lastBuildDate = lastBuildStage.date
      ? new Date(lastBuildStage.date)
      : new Date();

    const finishStageDate = new Date(lastBuildDate);
    finishStageDate.setMonth(finishStageDate.getMonth() + 2);

    const sortedStages = [
      ...startStages,
      ...sortedBuildStages,
      { ...finishStage, date: format(finishStageDate, "yyyy-MM-dd") },
    ];

    setFieldValue("stages", sortedStages);
  };

  return (
    <Stages
      activeTab={activeTab}
      isDesktop={isDesktop}
      values={values}
      stagesOptions={stagesOptions}
      calculatorType={calculatorType}
      onAddStageClick={handleAddStageClick}
      onSortByDateClick={handleSortByDateClick}
      onRemoveStageClick={handleRemoveStageClick}
    />
  );
};

export default StagesContainer;
